import React from 'react'
import { HelpCircleIcon, PlusIcon } from 'lucide-react'
import {
  DcButton,
  PixelFactoryContext,
  PixelFlexBox,
  DcInput,
  DcOverlaySlider,
  colors,
  DcText,
  DcDiv,
} from 'pixel-base'
import { AjaxResponse } from 'rxjs/ajax'

import { registerCustomerStore } from 'utils/api-routes.util'

import HelpShopify from './HelpShopify'
import { IPixelFactory } from '../../../../../decl'
import { CloseIcon } from '../../../../utils/icons/close-icon'

type Props = {
  origin: string
  onSuccessAddStore: () => void
}

const ShopifyManual = (props: Props) => {
  const { onSuccessAddStore } = props

  const [showHelp, setShowHelp] = React.useState(false)
  const { showSuccess, showFailure, showPageLoader, hidePageLoader } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const [error, setError] = React.useState({
    error: '',
    field: '',
  })
  const [data, setData] = React.useState({
    store_id: null,
    store_type: 'shopify',
    store_name: '',
    api_key: '',
    api_secret: '',
    host_url: '',
  })

  const handleSubmit = (e) => {
    e.preventDefault()
    handleAddStore(data)
  }

  const handleAddStore = (data) => {
    showPageLoader()
    registerCustomerStore(data).subscribe((res: AjaxResponse<any>) => {
      hidePageLoader()
      if (res.response.data) {
        showSuccess('Store added successfully')
        onSuccessAddStore()
      } else {
        if (res.response.error && res.response.field) {
          setError({
            error: res.response.error,
            field: res.response.field,
          })
        } else {
          showFailure(res.response.error)
        }
      }
    })
  }

  return (
    <>
      <PixelFlexBox position="relative" flexDirection="column">
        <form onSubmit={handleSubmit}>
          <PixelFlexBox
            justifyContent="flex-start"
            alignItems="flex-end"
            flexDirection="column"
            gap="10px"
          >
            <DcDiv
              width="100%"
              height="auto"
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flexStart',
              }}
            >
              <DcText
                style={{
                  textAlign: 'left',
                  color: colors.grayTextDark,
                  fontSize: '.875rem',
                  fontWeight: '500',
                  marginBottom: '.5rem',
                }}
              >
                Store Name
              </DcText>
              <DcInput
                error={
                  error.field === 'store_name' && error.error !== ''
                    ? error.error
                    : null
                }
                required
                placeholder="Store Name"
                value={data.store_name}
                onChange={(e) =>
                  setData({
                    ...data,
                    store_name: e.currentTarget.value,
                  })
                }
              />
            </DcDiv>
            <DcDiv
              width="100%"
              height="auto"
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flexStart',
              }}
            >
              <DcText
                style={{
                  textAlign: 'left',
                  color: colors.grayTextDark,
                  fontSize: '.875rem',
                  fontWeight: '500',
                  marginBottom: '.5rem',
                }}
              >
                Website URL
              </DcText>
              <DcInput
                error={
                  error.field === 'host_url' && error.error !== ''
                    ? error.error
                    : null
                }
                required
                placeholder="Website URL e.g. mystore.myshopify.com"
                value={data.host_url}
                onChange={(e) =>
                  setData({
                    ...data,
                    host_url: e.currentTarget.value,
                  })
                }
              />
            </DcDiv>
            <DcDiv
              width="100%"
              height="auto"
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flexStart',
              }}
            >
              <DcText
                style={{
                  textAlign: 'left',
                  color: colors.grayTextDark,
                  fontSize: '.875rem',
                  fontWeight: '500',
                  marginBottom: '.5rem',
                }}
              >
                API Key / Username
              </DcText>
              <DcInput
                error={
                  error.field === 'api_key' && error.error !== ''
                    ? error.error
                    : null
                }
                required
                placeholder="API Key / Username"
                value={data.api_key}
                onChange={(e) =>
                  setData({
                    ...data,
                    api_key: e.currentTarget.value,
                  })
                }
              />
            </DcDiv>
            <DcDiv
              width="100%"
              height="auto"
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flexStart',
              }}
            >
              <DcText
                style={{
                  textAlign: 'left',
                  color: colors.grayTextDark,
                  fontSize: '.875rem',
                  fontWeight: '500',
                  marginBottom: '.5rem',
                }}
              >
                API Access token / Password
              </DcText>
              <DcInput
                error={
                  error.field === 'api_secret' && error.error !== ''
                    ? error.error
                    : null
                }
                required
                value={data.api_secret}
                onChange={(e) =>
                  setData({
                    ...data,
                    api_secret: e.currentTarget.value,
                  })
                }
                placeholder="API Access token / Password"
              />
            </DcDiv>
            <PixelFlexBox
              justifyContent="center"
              alignItems="center"
              gap="5px"
              width="100%"
            >
              <DcButton
                width="50%"
                withIcon={true}
                onClick={() => setShowHelp(true)}
                variant="secondary"
                style={{
                  justifyContent: 'center',
                  background: colors.primaryGradient2,
                }}
              >
                <HelpCircleIcon size={16} />
                <span>Help</span>
              </DcButton>
              <DcButton
                width="50%"
                withIcon={true}
                type="submit"
                variant="primary"
                style={{
                  justifyContent: 'center',
                  background: colors.primaryGradient,
                }}
              >
                <PlusIcon size={16} />
                <span>Add Store</span>
              </DcButton>
            </PixelFlexBox>
          </PixelFlexBox>
        </form>
      </PixelFlexBox>
      <DcOverlaySlider
        onClose={() => {
          setShowHelp(false)
        }}
        width="40%"
        title={'Add New Processor'}
        isOpen={showHelp}
      >
        <>
          <HelpShopify />
          <PixelFlexBox justifyContent="flex-end">
            <DcButton
              withIcon={true}
              size="sm"
              onClick={() => setShowHelp(false)}
            >
              <CloseIcon size={16} />
              <span>Close</span>
            </DcButton>
          </PixelFlexBox>
        </>
      </DcOverlaySlider>
    </>
  )
}

export default ShopifyManual
